module.exports = __webpack_public_path__ + "media/sortition_finished.8de2da7f.mp3";